import { render } from "./HorizontalPlaylistCardLoader.vue?vue&type=template&id=0d24756e"
import script from "./HorizontalPlaylistCardLoader.vue?vue&type=script&lang=js"
export * from "./HorizontalPlaylistCardLoader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-zain-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__